module.exports = __webpack_public_path__ + "img/GA.5dd42419.png";